import { useQuery } from '@tanstack/react-query'

import { PersonalizedProductListViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

import useUser from '@/utils/use-user'

import { showProductListExperiment } from './show-product-list-experiment'

import { LocationType } from '../type'

export function useFetchPersonalizedProducts(locationType: LocationType) {
    const { user } = useUser()
    const showPersonalizedProductList = showProductListExperiment(locationType, user ?? null)

    return useQuery<PersonalizedProductListViewModel>({
        queryKey: QueryKeys.HomePage.PersonalizedProducts(locationType),
        queryFn: () => {
            return fetchRequest({
                endpoint: `/personalized/product-list/${locationType}`,
                method: 'GET',
                serviceName: 'cml',
            })
        },
        staleTime: Infinity,
        enabled: showPersonalizedProductList,
    })
}
